import React from "react";
import { useAppSelector, useAppDispatch } from 'redux/hooks'
import {Button} from "primereact/button";
import {setClearFilters, setArchiveTableToggle, setDialogVisible, initialCompaniesData, setCompanyStateSave, clearCampaignContacts, setEditType, setErrorFields, setCampaignTrunkIds, setSelectedCompanyIndex} from "redux/actions/actions";
import {checkPermissions} from "../../../redux/permissions/permissionsUtils";
import {getDefaultAmdSettings} from "redux/api/api";

const CompaniesListNav = (props: any) => {
    const dispatch = useAppDispatch()
    const archiveTableToggle = useAppSelector(state => state.CompaniesListReducer.archiveTableToggle)
    const rolesVision = useAppSelector(state => state.RolesReducer.rolesVision) as unknown as Record<string, string[]>;
    const jwtToken = useAppSelector(state => state.UsersReducer.userData.jwtToken);
    const dialerPermissions = checkPermissions(rolesVision, 'Campaigns');

    const {
        create: hasCampaignsCreatePermission,
    } = dialerPermissions;

    const openCreateCampaignDialog = () => {
        props.setSelectedRowData?.(null);
        dispatch(setSelectedCompanyIndex(null));
        dispatch(initialCompaniesData());
        dispatch(setCampaignTrunkIds(null));
        dispatch(setDialogVisible(true));
        dispatch(setCompanyStateSave(true));
        dispatch(setArchiveTableToggle(true));
        dispatch(setErrorFields(null));
        dispatch(clearCampaignContacts());
        dispatch(setEditType(!!hasCampaignsCreatePermission));
        if (jwtToken?.jwtToken) {
            dispatch(getDefaultAmdSettings(jwtToken.jwtToken));
        }
    };

    return (
        <div className="table-buttons">
            <div>
                <Button onClick={() => { dispatch(setArchiveTableToggle(true))}}
                        label="Дайлер"
                        className={archiveTableToggle ? 'mr-2 mb-2' : 'p-button-secondary mr-2 mb-2'}
                />
                <Button onClick={() => { dispatch(setArchiveTableToggle(false))}}
                        label="Архів"
                        className={archiveTableToggle ? 'p-button-secondary mr-2 mb-2' : 'mr-2 mb-2'}
                />
            </div>
            <div className="desktop">
                {hasCampaignsCreatePermission && (<Button label="Створити кампанію"
                        icon="pi pi-plus"
                        className="mr-2 mb-2"
                        onClick={openCreateCampaignDialog}
                />)}
                <Button type="button" icon="pi pi-filter-slash" label="Очистити фільтри" className="p-button-outlined mr-2 mb-2" onClick={() => {dispatch(setClearFilters()); props.handleReset()}} />
            </div>
            <div className="mobile">
                {hasCampaignsCreatePermission && (<Button icon="pi pi-plus"
                        className="mr-2 mb-2"
                        onClick={openCreateCampaignDialog}
                />)}
                <Button type="button" icon="pi pi-filter-slash" className="p-button-outlined mr-2 mb-2" onClick={() => dispatch(setClearFilters())} />
            </div>
        </div>
    )
}

export default CompaniesListNav
